import { z } from 'zod';
import { capacityCalendarPeriodSchema } from './capacity.js';
export const squadPlanningPeriodsResponseSchema = z.object({
    data: z.object({
        sprintAnchorDate: z.iso.date(),
        sprintLengthWeeks: z.number().int().positive(),
        periods: z.array(capacityCalendarPeriodSchema).length(5),
    }),
});
const name = z.string().trim().min(1).max(160);
const sprintFields = z.object({ name, startDate: z.iso.date(), endDate: z.iso.date() }).strict();
export const squadSprintInputSchema = sprintFields.refine((value) => value.startDate <= value.endDate, {
    path: ['endDate'],
    message: 'End date must follow start date.',
});
export const squadSprintUpdateSchema = sprintFields
    .extend({ updatedAt: z.iso.datetime() })
    .refine((value) => value.startDate <= value.endDate, {
    path: ['endDate'],
    message: 'End date must follow start date.',
});
export const squadSprintSchema = sprintFields.extend({ id: z.uuid(), updatedAt: z.iso.datetime() });
export const squadSeedInputSchema = z
    .object({ tempoTeamIds: z.array(z.string().min(1).max(128)).min(1).max(500) })
    .strict();
export const squadSchema = z.object({
    id: z.uuid(),
    name,
    managerId: z.uuid().nullable(),
    active: z.boolean(),
    sourceTempoTeamId: z.string().nullable(),
    updatedAt: z.iso.datetime(),
    resourceIds: z.array(z.uuid()),
    projectIds: z.array(z.uuid()),
    sprints: z.array(squadSprintSchema),
    canManage: z.boolean(),
    canAdmin: z.boolean(),
});
export const squadsResponseSchema = z.object({ data: z.array(squadSchema) });
export const squadOptionsResponseSchema = z.object({
    data: z.object({
        users: z.array(z.object({ id: z.uuid(), name: z.string() })),
        resources: z.array(z.object({ id: z.uuid(), name: z.string() })),
        projects: z.array(z.object({ id: z.uuid(), name: z.string() })),
        tempoTeams: z.array(z.object({ id: z.string(), name: z.string() })),
    }),
});
export const squadCreateSchema = z
    .object({ name, managerId: z.uuid().nullable().default(null) })
    .strict();
export const squadAdminUpdateSchema = z
    .object({
    name: name.optional(),
    managerId: z.uuid().nullable().optional(),
    active: z.boolean().optional(),
    updatedAt: z.iso.datetime(),
})
    .strict();
export const squadMembershipUpdateSchema = z
    .object({
    resourceIds: z.array(z.uuid()).max(500),
    projectIds: z.array(z.uuid()).max(500),
    updatedAt: z.iso.datetime(),
})
    .strict();
//# sourceMappingURL=squads.js.map